<template>

  <v-select 
    multiple
    :taggable="taggable"
    :value="currentValue"
    @input="input"
    :options="allOptions"
    label="label"
    :placeholder="placeholder"
    ref="vselect"
    :onSearch="searchEmail"
    :selectOnTab="true">
    </v-select>

</template>

<script>
import extractEmail from '@/utils/ExtractEmail'

export default {
  name: 'SelectizeEmail',
  props: {
    'value': {
      type: Array,
      default: () => { return null }
    },
    'options': {
      type: Array,
      default: () => { return [] }
    },
    'taggable': {
      type: Boolean,
      default: true
    },
    'placeholder': {
      type: String,
      default: function () {
        return this.$t('Enter e-mails')
      }
    }
  },
  data () {
    return {
      searchOptions: []
    }
  },
  computed: {
    currentValue () {
      if (this.value) {
        return this.value.map((val) => {
          return this.setLabel(val)
        })
      }
      return this.value
    },
    allOptions () {
      return [
        ...this.options,
        ...this.searchOptions
      ].map((val) => {
        return this.setLabel(val)
      })
    }
  },
  created () {
  },
  methods: {
    setLabel (val) {
      return Object.assign(val, {
        label: (val.name === val.email || !val.name) ? val.email : `${val.name} <${val.email}>`
      })
    },
    input (values) {
      if (values) {
        values = values.map((val) => {
          return val.email ? val : extractEmail(val.label || val)
        })
      } else {
        values = []
      }

      // quando input é definido, v-select redispara input
      // isso faz o controle para nao entrar em loop infinito
      if (JSON.stringify(values) !== JSON.stringify(this.value)) {
        this.$refs['vselect'].$refs['search'].focus()
        this.$emit('input', values.filter(v => v))
      }
    },
    searchEmail (search, loading) {
      loading(true)
      return this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/autocomplete/emails', {params: {q: search}})
      .then((response) => {
        this.searchOptions = response.data
        loading(false)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectizeMultipleEmail.vue